window.addEventListener('DOMContentLoaded', function () {
  if( (filters=document.querySelectorAll('[data-filter-fuzzy]')).length > 0 ) {
    for( var i = 0; i < filters.length; i++ ) {
      let filterSelector = filters[i].getAttribute('data-filter-fuzzy')
      filters[i].addEventListener( 'keyup', e => {
        let term = e.target.value.replace(/\./gi, "").trim().toLowerCase()
        let list = document.querySelectorAll(filterSelector)
        for( var i = 0; i < list.length; i++ ) {
          var item = list[i];
          var itemText = item.innerText.replace(/\./gi, "").trim().toLowerCase()

          var computedStyle = window.getComputedStyle( item )
          if( computedStyle.display != 'none' ) {
            item.initialDisplay = computedStyle.display
          }
          item.style.display = ( itemText.indexOf( term ) !== -1 ) ? (item.initialDisplay ? item.initialDisplay : 'block') : 'none';
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./theme/_base/js/filter-fuzzy.js